import api from './api'

export interface DemoCreatePayload {
  first_name: string
  email: string
  language: 'pl' | 'en' | 'de' | 'fr' | 'es' | 'it' | 'pt' | 'cs' | 'hu' | 'nl' | 'fi' | 'da' | 'sv' | 'no' | 'lt' | 'hr' | 'ro'
}

export interface DemoCreateResponse {
  token: string
  token_type: string
  demo_account_id: number
  user: { uuid: string; email: string; demo_email: string; is_demo: boolean }
  club: { uuid: string; name: string; is_demo: boolean }
}

export interface DemoFromMailResponse {
  token: string
  token_type: string
  // false: the recipient already had a demo from this mail and is logged into it again
  created: boolean
  demo_account_id: number
  user: { uuid: string; email: string; demo_email: string; is_demo: boolean; demo_status: 'active' }
  club: { uuid: string; name: string; is_demo: boolean }
}

export const createDemoAccount = (payload: DemoCreatePayload) =>
  api.post<DemoCreateResponse>('v1/auth/demo', payload).then(r => r.data)

export const verifyDemoCode = (code: string) =>
  api.post<{ status: string }>('v1/auth/demo/verify', { code }).then(r => r.data)

export const resendDemoCode = () =>
  api.post<{ expires_at: string }>('v1/auth/demo/resend').then(r => r.data)

// Demo link in a mail from the admin panel: the mail link token replaces the code
export const enterDemoFromMail = (token: string) =>
  api.post<DemoFromMailResponse>('v1/auth/demo/invite', { token }).then(r => r.data)
